<template>
    <div id="menu">
        <div class="modal fade in" style="display: block;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ $t('finish.finished') }}</h4>
                    </div>
                    <div class="modal-body">
                        <p>
                            {{ $t('menu.team_name') }}: {{team.name}}<br>
                            {{ $t('menu.score') }}: {{team.score}}
                        </p>
                        <p v-if="event.comments && event.comments.outro">{{event.comments.outro}}</p>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-link text-danger" @click="exit()">
                            <i class="fa fa-sign-out" aria-hidden="true"></i>
                            {{ $t('common.exit') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data () {
            return {
            }
        },
        computed: mapState({
            event: state => state.events.activeEvent,
            team: state => state.teams.activeTeam
        }),
        methods: {
            exit() {
                this.$store.commit('EXIT_GAME')
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// finish.vue?7fee7dbd